import { css, cx } from '@emotion/css';
import { isMobile } from '../utils';
const mobileContainerStyle = css `
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    label: MobileSingleContainer;
`;
const mobileContainerStyleNoRemove = css `
    margin-bottom: 2px;
`;
const mobileMultipageContainerStyle = css `
    margin-bottom: unset;
`;
export const getThumbnailStyle = ({ isMultiPage, styleOptions, hasRemoveBtn }) => {
    const size = isMultiPage ? styleOptions.thumbnailSize * 0.9 : styleOptions.thumbnailSize;
    const containerStyle = css `
        position: relative;
        &:hover > button,
        &:focus-within > button {
            visibility: visible;
            &:after {
                opacity: 1;
            }
        }

        &:focus-within > button > div,
        &:hover > button > div {
            &:after {
                background: rgba(0, 0, 0, 0.3);
                border: 1px solid rgba(0, 0, 0, 0.3);
            }
        }

        height: ${size}px;
        width: ${size}px;
    `;
    return cx(containerStyle, {
        [mobileContainerStyle]: isMobile(),
        [mobileContainerStyleNoRemove]: isMobile() && !hasRemoveBtn,
        [mobileMultipageContainerStyle]: isMobile() && isMultiPage,
    });
};
//# sourceMappingURL=DrawerThumbnailStyles.js.map